import { Box } from '@inflearn/ds-react-next';
import { ASSETS } from '../../../../constants/redLightGreenLightConfig';
import { playerStyle } from './styles';
import type { RedLightGamePlayerProps } from './types';

export const RedLightGamePlayer = ({
  x,
  y,
  isCaught,
  isWalking,
  walkFrame,
}: RedLightGamePlayerProps) => {
  const getPlayerSprite = () => {
    if (isCaught) {
      return ASSETS.player.caught;
    }
    if (isWalking) {
      return walkFrame === 0 ? ASSETS.player.walk1 : ASSETS.player.walk2;
    }
    return ASSETS.player.idle;
  };

  return (
    <Box
      css={playerStyle(x, y, isCaught)}
      style={{
        backgroundImage: `url(${getPlayerSprite()})`,
      }}
    />
  );
};
